import request from '@/utils/request';
export function getMenusTree(pid) {
  return request({
    url: 'api/menus/list?pid=' + pid,
    method: 'get'
  });
}
export function getMenus(params) {
  return request({
    url: 'api/menus/list',
    method: 'get',
    params: params
  });
}
export function getMenuSuperior() {
  // const data = Array.isArray(ids) || ids.length === 0 ? ids : Array.of(ids)
  return request({
    url: 'api/menus/superior',
    method: 'get'
  });
}
export function getChild(id) {
  return request({
    url: 'api/menus/child?id=' + id,
    method: 'get'
  });
}
export function buildMenus() {
  return request({
    url: 'api/menus/build',
    method: 'get'
  });
}
export function add(data) {
  return request({
    url: 'api/menus',
    method: 'post',
    data: data
  });
}
export function del(ids) {
  return request({
    url: 'api/menus',
    method: 'delete',
    data: ids
  });
}
export function edit(data) {
  return request({
    url: 'api/menus',
    method: 'put',
    data: data
  });
}
export function recursion(obj) {
  if (!obj.children) {
    obj.children = undefined;
    return;
  }
  obj.children.map(function (e) {
    recursion(e);
  });
}
export function updateStatus(data) {
  return request({
    url: 'api/menus/updateHidden',
    method: 'put',
    data: data
  });
}
export default {
  add: add,
  edit: edit,
  del: del,
  getMenusTree: getMenusTree,
  getMenuSuperior: getMenuSuperior,
  getMenus: getMenus,
  getChild: getChild,
  recursion: recursion,
  updateStatus: updateStatus
};